export function getSkillsLink(skillIds: string[]) {
  const urlParams = new URLSearchParams(skillIds.map((id) => ['skills', id]));
  return `/app/skills/start?${urlParams}`;
}
